// import { mapGetters } from 'vuex'

// computed: {
//   ...mapGetters([
//     // 员工
//     'aaa',
//   ])
// }
// bmsState: {
//   get: function() {
//     let state = this.$store.getters.bmsState

//     if (state === false) {
//       this.bmsArr2 = []
//     }
    
//     return state
//   },
//   set: function(newVal) {
//     this.$store.commit('SET_BMSSTATE', newVal)
//   }
// }

// 赋值：this.$store.commit('SET_AAA', 'aaa')
const temp = {
  state: {
    aaa: '999'
  },

  mutations: {
    SET_AAA: (state, val) => {
      state.aaa = val
    },
  },

  actions: {
    
  }
}

export default temp



// WEBPACK FOOTER //
// ./src/store/modules/atemp.js